import { LDFlagSet } from "launchdarkly-react-client-sdk";

import { IFacetGroup } from "shared/models/facet";

import { IJobItem } from "models/job";

import { IConverter } from "services/api/types";

import { IJobTableItem } from "components/JobsTable/JobsTable.models";

import {
  IPrepareAdditionalInfoTexts,
  IPrepareJobLabelTexts,
  IPrepareJobSenderTexts,
  IPrepareJobTitleTexts,
  prepareAdditionalInfo,
  prepareJobLabel,
  prepareJobSender,
  prepareJobTags,
  prepareJobTitle,
  prepareJobUrl,
  prepareJobUuid,
} from "./shared.helpers";
import { AccountType } from "shared-types";
import { FEATURE_FLAGS } from "shared-services";

export type JobItemToJobTableItemConverterTexts = IPrepareAdditionalInfoTexts &
  IPrepareJobTitleTexts &
  IPrepareJobSenderTexts &
  IPrepareJobLabelTexts;

export class JobItemToJobTableItemConverter
  implements IConverter<IJobItem, IJobTableItem>
{
  constructor(
    private texts: JobItemToJobTableItemConverterTexts,
    private productionTypes: IFacetGroup[],
    private contractTypes: IFacetGroup[]
  ) {}

  convert = (
    jobItem: IJobItem,
    ldFlags?: LDFlagSet,
    userType?: AccountType
  ): IJobTableItem => {
    const showRoleCastLabel =
      ldFlags?.[FEATURE_FLAGS.RoleCast] &&
      userType === AccountType.Performer &&
      jobItem.isCast;

    return {
      type: jobItem.type,
      url: prepareJobUrl(jobItem),
      id: prepareJobUuid(jobItem),
      sender: prepareJobSender(jobItem.senderId, jobItem.sender, this.texts),
      labels: prepareJobLabel(jobItem, this.texts, showRoleCastLabel),
      title: prepareJobTitle(jobItem, this.texts, this.productionTypes),
      isRead: jobItem.isRead,
      additionalInfo: prepareAdditionalInfo(jobItem, this.texts),
      tags: prepareJobTags(jobItem, this.productionTypes, this.contractTypes),
    };
  };
}
